export const BUSINESS = {
  name: 'Majestic Greens DMV',
  phone: '(202) 320-7287',
  phoneHref: 'tel:+12023207287',
  address: '425 7th St NW',
  city: 'Washington',
  state: 'DC',
  zip: '20004',
  founded: 2018,
  minOrder: 40,
  hours: 'Open Daily 10:00 AM – 11:00 PM',
  hoursSchema: 'Mo-Su 10:00-23:00',
};

export const LOGO_URL =
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_11101c2d-c5f4-4bc4-873e-03aae645b44a/artifacts/w5mp42ks_8dd651d96092f8d47286f06e725d9ed3.png-2.webp';

export const STORE_URL = 'https://majesticgreensdmv.com';

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1786021456186-071a4d1fb8a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjYW5uYWJpcyUyMHBsYW50JTIwZGFyayUyMG1vb2R5JTIwbWFjcm98ZW58MHx8fHwxNzg3MjM1NjcyfDA&ixlib=rb-4.1.0&q=85',
  dc: 'https://images.unsplash.com/photo-1617293541287-5530026ca9b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB3YXNoaW5ndG9uJTIwZGMlMjBzdW5zZXQlMjBza3lsaW5lfGVufDB8fHx8MTc4NzIzNTY3Mnww&ixlib=rb-4.1.0&q=85',
  edibles: 'https://images.unsplash.com/photo-1690583367360-f1d947366515?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxndW1teSUyMGNhbmR5JTIwbW9vZHklMjBsaWdodGluZ3xlbnwwfHx8fDE3ODcyMzU2NzJ8MA&ixlib=rb-4.1.0&q=85',
  vapes: 'https://images.pexels.com/photos/23319711/pexels-photo-23319711.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
};

export const CATEGORY_CARDS = [
  { title: 'Exotic Flower', slug: 'exotic', blurb: 'Top-shelf exotic strains', size: 'large' },
  { title: 'Pre-Rolls', slug: 'prerolls', blurb: 'Ready to enjoy' },
  { title: 'Vapes & Carts', slug: 'cartridges', blurb: 'THC cartridges', img: IMAGES.vapes },
  { title: 'Edibles', slug: 'edibles', blurb: 'Gummies & more', img: IMAGES.edibles },
  { title: 'Concentrates', slug: 'concentrates', blurb: 'Diamonds, wax & extracts' },
  { title: 'Indica', slug: 'indica', blurb: 'Deep relaxation' },
  { title: 'Sativa', slug: 'sativa', blurb: 'Uplifting energy' },
  { title: 'Hybrid', slug: 'hybrid', blurb: 'Best of both' },
  { title: 'Disposables', slug: 'disposable-cartridge', blurb: 'All-in-one vapes' },
  { title: 'Deals', slug: 'deal-discount', blurb: 'Bundles & offers', to: '/deals' },
];

export const MARQUEE_ITEMS = [
  'PREMIUM CANNABIS',
  'WASHINGTON DC',
  'EASY ONLINE ORDERING',
  'EXOTIC STRAINS',
  'LOCAL DC SERVICE',
  '$40 MINIMUM ORDER',
];
